"use client";

import { debounce } from "@/utils/debounce";
import { useEffect, useState } from "react";

export const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState({
    width: typeof window !== "undefined" ? window.innerWidth : 0,
    height: typeof window !== "undefined" ? window.innerHeight : 0,
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", debounce(handleResize, 300));

    handleResize();

    return () =>
      window.removeEventListener("resize", debounce(handleResize, 300));
  }, []);
  return windowSize;
};
